"use client";

import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "./ui/form";
import { Input } from "./ui/input";
import { useState, useTransition } from "react";
import { Button } from "./ui/button";
import { Loader2 } from "lucide-react";
import { toast } from "@/hooks/use-toast";
import { signUpAction } from "@/app/lib/actions/signup.actions";

// nom
// telephone
// adresse email]

const formSchema = z.object({
  signupName: z.string().min(3, "Le nom du contact est requis"),
  signupTelephone: z.string().min(3, "Le téléphone du contact est requis"),
  signupEmail: z.string().email("Cette adresse email n'est pas reconnue !"),
  signupComment: z.string().optional()
});
type FormData = z.infer<typeof formSchema>;
export default function SignupForm() {
  const form = useForm<FormData>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      signupName: "",
      signupTelephone: "",
      signupEmail: "",
      signupComment: ""
    }
  });
  const [isPending, startTransition] = useTransition();
  const [returnMessage, setRetrunMessage] = useState("");
  async function onSubmit(values: FormData) {
    startTransition(async () => {
      console.log("onSubmit");
      try {
        const {
          message,
          error
        }: {
          message: string | undefined;
          error: string | undefined;
        } = (await signUpAction(values.signupName, values.signupTelephone, values.signupEmail, values.signupComment)) || {};
        console.log("onSubmit/return", message, error);
        if (!message || error) {
          toast({
            variant: "destructive",
            title: "Erreur !",
            description: error || "Une erreur s'est produite. Veuillez réessayer plus tard.",
            duration: 5000
          });
          return;
        }
        setRetrunMessage(message);
      } catch (error) {
        console.log("onSubmit/error", error);
      }
    });
  }
  return <div className="" data-sentry-component="SignupForm" data-sentry-source-file="SignupForm.tsx">
      <Form {...form} data-sentry-element="Form" data-sentry-source-file="SignupForm.tsx">
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
          {/* Form fields */}

          <div className="flex flex-col gap-1 w-96">
            <FormField control={form.control} name="signupName" render={({
            field
          }) => <FormItem>
                  <FormLabel>Nom</FormLabel>
                  <FormControl>
                    <Input placeholder="Nom" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>} data-sentry-element="FormField" data-sentry-source-file="SignupForm.tsx" />
            <FormField control={form.control} name="signupTelephone" render={({
            field
          }) => <FormItem>
                  <FormLabel>Numéro de téléphone</FormLabel>
                  <FormControl>
                    <Input placeholder="Numéro de téléphone" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>} data-sentry-element="FormField" data-sentry-source-file="SignupForm.tsx" />
            <FormField control={form.control} name="signupEmail" render={({
            field
          }) => <FormItem>
                  <FormLabel>Email</FormLabel>
                  <FormControl>
                    <Input placeholder="Email" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>} data-sentry-element="FormField" data-sentry-source-file="SignupForm.tsx" />

          <FormField control={form.control} name="signupComment" render={({
            field
          }) => <FormItem>
                  <FormLabel>Localisation</FormLabel>
                  <FormControl>
                    <Input placeholder="Nom et adresse de votre hôtel, restaurant..." {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>} data-sentry-element="FormField" data-sentry-source-file="SignupForm.tsx" />

            {returnMessage && <div className="text-green-600 mt-9 font-bold">{returnMessage}</div>}

            <Button onClick={form.handleSubmit(onSubmit)} type="submit" disabled={isPending || !!returnMessage} className="w-full mt-10 bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors duration-200 shadow-md flex items-center justify-center disabled:bg-gray-400 disabled:cursor-not-allowed" data-sentry-element="Button" data-sentry-source-file="SignupForm.tsx">
              {isPending ? <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  En cours...
                </> : "Confirmer"}
            </Button>
          </div>
        </form>
      </Form>
    </div>;
}